import { useState, useEffect } from "react";
import { saveAssetMasterDetails } from "../../Api/AssetManagement";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useAssetContext } from '../../Context/MasterContext/AssetContext';
import { useMasterDataContext } from '../../Context/masterDataContext';

const AddAssets = () => {
  const navigate = useNavigate();
  const { assetCatTypes, loadCatTypes, assetConTypes,
    loadConTypes, assetTypes,
    loadAssetTypes,
    deprecMethod,
    loadDeprecMethod } = useAssetContext();
  const { departmentsData, loadDepartments, merchantsData,
    loadMerchants } = useMasterDataContext();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  console.log("UserId: ", userId);

  // console.log(assetCatTypes, 'assetCatTypes');
  // console.log(departmentsData, 'departmentsData');
  // console.log(merchantsData, 'merchantsData')
  // console.log(assetConTypes, 'assetConTypes')

  const intitalValues = {
    oeM_Barcode: "",
    // internal_BarcodeID: "",
    asset_Category: "",
    asset_Type: "",
    brand_Model: "",
    serial_No: "",
    department: "",
    purchase_Date: "",
    pO_Number: "",
    invoice_Number: "",
    invoice_Date: "",
    cost: "",
    supplier_Contact_Details: "",
    warranty_Expiry: "",
    vendor_AMCID: "",
    asset_Condition: "",
    depreciation_Method: "",
    depreciation_Rate: "",
    useful_Life: "",
    salvage_Value: "",
    date_of_Disposal: "",
    scrap_Value: "",
    Remarks: ""
  }

  const [formValues, setFormValues] = useState(intitalValues);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveAssetMasterDetails(formValues, userId);
      toast.success(`🦄 Added Successfully`);
      setFormValues(intitalValues);
      navigate("/assets/view-assets");
    } catch (error) {
      toast.error(`🦄 Error : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCatTypes();
    loadConTypes();
    loadDepartments();
    loadMerchants();
    loadAssetTypes();
    loadDeprecMethod();
  }, []);

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Add New Asset</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>OEM Bar code<span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="oeM_Barcode"
                    value={formValues.oeM_Barcode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              {/* <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Internal Barcode ID<span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="internal_BarcodeID"
                    value={formValues.internal_BarcodeID}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col> */}
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Category <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="asset_Category"
                    value={formValues.asset_Category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Category</option>
                    {assetCatTypes.map((option) => (
                      <option key={option.assetCategoryId} value={option.assetCategoryId}>
                        {option.assetCategoryDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Type <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="asset_Type"
                    value={formValues.asset_Type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    {assetTypes.map((option) => (
                      <option key={option.assetTypeID} value={option.assetTypeID}>
                        {option.assetTypeDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Brand <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="brand_Model"
                    value={formValues.brand_Model}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Serial Number <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="serial_No"
                    value={formValues.serial_No}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Department <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="department"
                    value={formValues.department}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Department</option>
                    {departmentsData.map((option) => (
                      <option key={option.code} value={option.code}>
                        {option.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Purchase Date <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="date"
                    name="purchase_Date"
                    value={formValues.purchase_Date}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>PO Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="pO_Number"
                    value={formValues.pO_Number}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Invoice Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="invoice_Number"
                    value={formValues.invoice_Number}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Invoice Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="invoice_Date"
                    value={formValues.invoice_Date}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Cost <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="number"
                    name="cost"
                    value={formValues.cost}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Supplier Contact Details</Form.Label>
                  <Form.Control
                    type="text"
                    name="supplier_Contact_Details"
                    value={formValues.supplier_Contact_Details}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Warranty Expiry</Form.Label>
                  <Form.Control
                    type="date"
                    name="warranty_Expiry"
                    value={formValues.warranty_Expiry}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Vendor ID</Form.Label>
                  <Form.Select
                    name="vendor_AMCID"
                    value={formValues.vendor_AMCID}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Vendor</option>
                    {merchantsData.map((option) => (
                      <option key={option.merchantCode} value={option.merchantCode}>
                        {option.merchantCode} - {option.merchantName}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Asset Condition <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="asset_Condition"
                    value={formValues.asset_Condition}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Condition</option>
                    {assetConTypes.map((option) => (
                      <option key={option.conditionId} value={option.conditionId}>
                        {option.conditionDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Depreciation Method <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="depreciation_Method"
                    value={formValues.depreciation_Method}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Method</option>
                    {deprecMethod.map((option) => (
                      <option key={option.methodCode} value={option.methodCode}>
                        {option.methodDesc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Depreciation Rate (%)</Form.Label>
                  <Form.Control
                    type="number"
                    name="depreciation_Rate"
                    value={formValues.depreciation_Rate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Useful Life (years)</Form.Label>
                  <Form.Control
                    type="number"
                    name="useful_Life"
                    value={formValues.useful_Life}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Salvage Value</Form.Label>
                  <Form.Control
                    type="number"
                    name="salvage_Value"
                    value={formValues.salvage_Value}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* </Row> */}

              {/* <Row> */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Disposal</Form.Label>
                  <Form.Control
                    type="date"
                    name="date_of_Disposal"
                    value={formValues.date_of_Disposal}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Scrap Value</Form.Label>
                  <Form.Control
                    type="number"
                    name="scrap_Value"
                    value={formValues.scrap_Value}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="Remarks"
                    value={formValues.Remarks}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Asset"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default AddAssets;